import {Formik} from "formik";
import CustomTabMenu from "../component/CustomTabMenu";
import {danhSachTabHTKT} from "./Components/Tabs";

export const HoTroKyThuat: React.FC = () => {
  return (
    <Formik<any> initialValues={{}} onSubmit={() => {
    }}>
      <div className="bg-white h-100">
        <div className="flex-1 flex flex-column">
          <CustomTabMenu
            childrenTab
            danhsachTabs={danhSachTabHTKT()}
            className="spaces pl-0"
          />
        </div>
      </div>
    </Formik>
  );
};

export default HoTroKyThuat;
